// import Swiper JS
import Swiper, { Navigation, Pagination, EffectFade, Autoplay} from 'swiper';
// import Swiper styles
import 'swiper/swiper-bundle.css';
Swiper.use([Navigation, Pagination, EffectFade, Autoplay]);

const swiper = new Swiper('.swiper-container', {
    // Optional parameters
    effect: 'fade',
    fadeEffect: {
        crossFade: true
    },

    autoplay: {
        delay: 5000,
    },
    direction: 'horizontal',
    loop: true,

    // If we need pagination
    pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
    },

    // Navigation arrows
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },

    // And if we need scrollbar
    // scrollbar: {
    //     el: '.swiper-scrollbar',
    // },
});

export default swiper;





// import Swiper, {Navigation, Lazy, Keyboard, A11y, EffectCoverflow} from 'swiper';
// import 'swiper/swiper-bundle.css';
// Swiper.use([Navigation, Lazy, Keyboard, A11y, EffectCoverflow]);
//
// const initSliders = () => {
//
//     if (document.querySelectorAll('.ume-slider-galleries').length > 0) {
//
//         const galleries = document.querySelectorAll('.ume-slider-galleries');
//         galleries.forEach(gallery => {
//             const swiperContainer = gallery.querySelector('.swiper-container');
//             const newSlider = new Swiper(swiperContainer, {
//                 direction: 'horizontal',
//                 grabCursor: 'true',
//                 speed: 600,
//                 loop: true,
//                 lazy: true,
//                 updateOnWindowResize: true,
//                 preloadImages: false,
//                 coverflowEffect: {
//                     depth: 100,
//                 },
//                 keyboard: {
//                     enabled: true,
//                     onlyInViewport: false,
//                 },
//                 a11y: {
//                     prevSlideMessage: 'Zurück',
//                     nextSlideMessage: 'Weiter'
//                 },
//                 centeredSlides: false,
//                 watchSlidesVisibility: true,
//                 breakpoints: {
//                     1400: {
//                         slidesPerView: 4,
//                         spaceBetween: 47,
//                     },
//                     1200: {
//                         slidesPerView: 3,
//                         spaceBetween: 16,
//                     },
//                     769: {
//                         slidesPerView: 2,
//                         spaceBetween: 16,
//                     },
//                     400: {
//                         slidesPerView: 1,
//                         spaceBetween: 16,
//                     },
//
//                 },
//                 navigation: {
//                     nextEl: swiperContainer.nextElementSibling.nextElementSibling,
//                     prevEl: swiperContainer.nextElementSibling,
//                 },
//                 on: {
//                     init: () => {
//
//                         const activeSlides = gallery.querySelectorAll('.swiper-slide-visible');
//                         if (activeSlides.length === 4) {
//                             activeSlides[0].classList.add('caravan-fun-slider-side-slides');
//                             activeSlides[3].classList.add('caravan-fun-slider-side-slides');
//                         }
//                         if (activeSlides.length === 3) {
//                             activeSlides[0].classList.add('caravan-fun-slider-side-slides');
//                             activeSlides[2].classList.add('caravan-fun-slider-side-slides');
//                         }
//                     }
//                 }
//             });
//
//             newSlider.on('setTransition', () => {
//
//                 const currentSlider = newSlider.el;
//                 const slides = currentSlider.querySelectorAll('.swiper-slide');
//                 const activeSlides = currentSlider.querySelectorAll('.swiper-slide-visible');
//                 slides.forEach(el => {
//
//                     el.classList.remove('caravan-fun-slider-side-slides')
//                 })
//                 if (activeSlides.length === 4) {
//                     activeSlides[0].classList.add('caravan-fun-slider-side-slides');
//                     activeSlides[3].classList.add('caravan-fun-slider-side-slides');
//                 }
//                 if (activeSlides.length === 3) {
//                     activeSlides[0].classList.add('caravan-fun-slider-side-slides');
//                     activeSlides[2].classList.add('caravan-fun-slider-side-slides');
//                 }
//             })
//
//         });
//     }
// }
//
// export default initSliders;